"use client";

import { useEffect } from "react";
import { api } from "~/trpc/react";
import Quiz from "./quiz";
import { type QuizQuestion } from "~/types/quiz";
import { useRouter } from "next/navigation";
import { useSession } from "next-auth/react";
import { pushGA4Event } from "~/lib/ga4-browser";
import { capturePostHogEvent } from "~/lib/posthog/client";

export default function QuizPage({
  questions,
  id,
  title,
}: {
  questions: QuizQuestion[];
  id: string;
  title: string;
}) {
  const router = useRouter();
  const { data: session } = useSession();

  useEffect(() => {
    capturePostHogEvent("quiz_started", { quiz_id: id });
  }, [id]);

  const quiz = api.ai.quiz.useMutation({
    onSuccess: () => {
      pushGA4Event("quiz_complete", { content_id: id });
      capturePostHogEvent("quiz_completed", { quiz_id: id });
    },
  });

  return (
    <Quiz
      questions={questions}
      quizType={id}
      title={title}
      onSubmitSuccess={async (data) => {
        const result = await quiz.mutateAsync({
          email: data.email,
          quizType: id,
          newsletterOptIn: data.newsletterOptIn,
          answers: data.answers,
        });
        const resultUrl = session?.user
          ? `/app/testovi/${id}/${result.id}`
          : `/testovi/${id}/${result.id}`;

        router.push(resultUrl);
      }}
    />
  );
}
